<template lang="pug">
div.mt-4
  v-row
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Redemption revenue
        div.d-flex.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ stats.redemption_revenue | displayPrice($currency) }}
  v-row
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total customers engaged
        div.d-flex.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ stats.total_audiences | displayNumber }}
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total code issued
        div.d-flex.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ stats.total_code_issued | displayNumber }}
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total offers redeemed
        div.d-flex.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ stats.total_redeemed | displayNumber }}
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Redemption rate
        div.d-flex.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
        div.text-g5.mt-4(v-else) {{ Math.floor(stats.total_redeemed/stats.total_code_issued) }}%
  v-row
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total successful sent SMS
        div.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div(style="width: 100%")
            v-skeleton-loader.mt-7(type="text")
            v-skeleton-loader.mt-2(type="text")
            v-skeleton-loader.mt-2(type="text")
        template(v-else-if="stats.sms")
          div.text-g5.mt-4 {{ stats.sms.total_sent }}
          div.d-flex.align-center.mt-5
            div.text-sm.font-medium.neutral500--text Total SMS blasted
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.sms.total_blasted | displayNumber }}
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total successful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.sms.total_sent | displayNumber }} ({{ Math.floor(stats.sms.total_sent*100/stats.sms.total_blasted) || 0 }}%)
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total unsuccessful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text  {{ (stats.sms.total_blasted - stats.sms.total_sent) | displayNumber }} ({{ Math.floor((stats.sms.total_blasted - stats.sms.total_sent)*100/stats.sms.total_blasted) || 0 }}%)
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total successful sent Email
        div.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div(style="width: 100%")
            v-skeleton-loader.mt-7(type="text")
            v-skeleton-loader.mt-2(type="text")
            v-skeleton-loader.mt-2(type="text")
        template(v-else-if="stats.email")
          div.text-g5.mt-4 {{ stats.email.total_sent }}
          div.d-flex.align-center.mt-5
            div.text-sm.font-medium.neutral500--text Total email blasted
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.email.total_blasted | displayNumber }}
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total successful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.email.total_sent | displayNumber }} ({{ Math.floor(stats.email.total_sent*100/stats.email.total_blasted) || 0 }}%)
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total unsuccessful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ (stats.email.total_blasted - stats.email.total_sent) | displayNumber }} ({{ Math.floor((stats.email.total_blasted - stats.email.total_sent)*100/stats.email.total_blasted) || 0 }}%)
    v-col
      v-card.border.rounded-lg.pa-6(outlined)
        div.text-sm.font-medium.neutral500--text Total successful sent WhatsApp
        div.mt-4.mb-1(v-if="isFetching")
          v-progress-circular(:width="3" :size="28" color="neutral500" indeterminate)
          div(style="width: 100%")
            v-skeleton-loader.mt-7(type="text")
            v-skeleton-loader.mt-2(type="text")
            v-skeleton-loader.mt-2(type="text")
        template(v-else-if="stats.whatsapp")
          div.text-g5.mt-4 {{ stats.whatsapp.total_sent }}
          div.d-flex.align-center.mt-5
            div.text-sm.font-medium.neutral500--text Total WhatsApp blasted
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.whatsapp.total_blasted | displayNumber }}
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total successful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ stats.whatsapp.total_sent | displayNumber }} ({{ Math.floor(stats.whatsapp.total_sent*100/stats.whatsapp.total_blasted) || 0 }}%)
          v-divider.my-1
          div.d-flex.align-center
            div.text-sm.font-medium.neutral500--text Total unsuccessful deliveries
            v-spacer
            div.text-sm.font-medium.neutral700--text {{ (stats.whatsapp.total_blasted - stats.whatsapp.total_sent) | displayNumber }} ({{ Math.floor((stats.whatsapp.total_blasted - stats.whatsapp.total_sent)*100/stats.whatsapp.total_blasted) || 0 }}%)

  div.py-16

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {},
  data () {
    return {
      isFetching: false,
      stats: {},
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer'
    })
  },
  mounted () {
    this.fetchOfferInsights()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchOfferInsights () {
      this.isFetching = true
      this.$axios.get(`/marketing/${this.company.slug}/offers/stats`, { params: { ids: this.storedOffer.id } })
        .then(resp => {
          this.stats = resp.data
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  cursor: default;
}
</style>